var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('p',[_vm._v("Based on a start date of")]),_vm._v(" "),_c('datepicker',{staticClass:"datepicker",attrs:{"value":_vm.selectedDate,"format":"d MMMM yyyy"},on:{"selected":_vm.dateChanged}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }